import { Controller } from "@hotwired/stimulus";

export class DatePickerFormController extends Controller {
  connect() {
    jQuery(this.element).addDateAndTimePickers();
  }
}
